import { useEffect } from "react";
import {
  Nav,
  Hero,
  TrustStrip,
  LogoStrip,
  DevelopmentOverview,
  HowItWorks,
  ServicesGrid,
  HorizontalFeatures,
  MarketingCreative,
  CaseStudies,
  Testimonials,
  FAQ,
  FinalCTA,
  Blog,
  Footer,
} from "../App";

/**
 * HomeV4 — experimental variant.
 * Clone of V3. Diverge freely: reorder sections, swap components,
 * build V4-only subcomponents in this file (or alongside it).
 */
export default function HomeV4() {
  useEffect(() => {
    document.title = "Sunday Digital — V4";
  }, []);

  return (
    <div
      data-testid="home-page"
      data-variant="v4"
      className="min-h-screen bg-[#0B0F14] text-neutral-100 font-body"
    >
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <LogoStrip />
        <DevelopmentOverview />
        <HowItWorks />
        <ServicesGrid />
        <HorizontalFeatures />
        <MarketingCreative />
        <CaseStudies />
        <Testimonials />
        <FAQ />
        <FinalCTA />
        <Blog />
      </main>
      <Footer />
    </div>
  );
}
